import { ImageTypeBreakpointEnum } from '@core/enums/image-type-breakpoint.enum';
import { ImageInterface } from '@core/interfaces/image.interface';
import { IQueryImages } from 'src/app/home-page/services/bootstrap-query.service';

/** Map with <type, name>
 * @example { 2: 'xs' }
 */
export const TYPE_BREAKPOINT_MAP = new Map<number, ImageTypeBreakpointEnum>(
  Object.entries(ImageTypeBreakpointEnum).reduce((acc, [type, name]: any) => {
    if (!isNaN(type)) acc.push([+type, name]);
    return acc;
  }, []),
);

/** Get images by breakpoint name
 * @example { xs: 'imges.example.com/image-xs.jpg', lg: 'imges.example.com/image-lg.jpg' }
 */
export function imagesByBreakpoint(images: Array<Omit<ImageInterface, 'id'>>): IQueryImages {
  return Object.fromEntries(
    images.map((img) => [TYPE_BREAKPOINT_MAP.get(img.tipo), img.imagen]),
  ) as unknown as IQueryImages;
}
